import { Box } from "@mui/material"
import type { FC } from "react"

import { useProductCostBreakdownsTable } from "../hooks/useProductCostBreakdownsTable"

import { ProductCostBreakdownsTable } from "./ProductCostBreakdownsTable"

export const ProductCostBreakdownsContainer: FC = () => {
  const {
    rows,
    isLoading,
    expandedState,
    sortingState,
    tableContainerRef,
    handleExpandedChange,
    handleSortingChange,
    handleScroll,
  } = useProductCostBreakdownsTable()

  return (
    <Box className='flex h-full flex-col gap-y-6'>
      <ProductCostBreakdownsTable
        data={rows}
        isLoading={isLoading}
        expandedState={expandedState}
        sortingState={sortingState}
        tableContainerRef={tableContainerRef}
        onExpandedChange={handleExpandedChange}
        onSortingChange={handleSortingChange}
        onScroll={handleScroll}
      />
    </Box>
  )
}
